module.exports = __webpack_public_path__ + "img/banner-blue-note.412d25be.png";